import { Form } from 'components/Wizards/Form/Form'
import { Field } from 'components/Wizards/Field/Field'
import { Input } from 'almanac-ui/TextInputField/Input'
import Styles from '../../Source.module.scss'

import { MouseEventHandler } from 'react'
import { WebsiteScrapingErrorCode } from 'hooks/useFetchReference'
import { FormikProps } from 'formik'
import { Values } from 'components/Wizards/schemas/TurnInto'
import { Text } from 'blaze-ui/Text/Text'

export interface WebsiteSourceProps {
  formikProps: FormikProps<Values>
  contentUrl?: string
  isValid: boolean
  errorMessage?: string | JSX.Element
  analyzeContent: () => void
  setContentUrl: (url: string) => MouseEventHandler<HTMLAnchorElement>
  scrapingError?: WebsiteScrapingErrorCode
}

export const WebsiteSource = ({
  formikProps,
  contentUrl,
  isValid,
  errorMessage,
  analyzeContent,
  setContentUrl,
  scrapingError,
}: WebsiteSourceProps) => {
  if (!!scrapingError) {
    return (
      <Form.Fields className={Styles.container}>
        <div>
          <Text variant="largeList" color="var(--dark-80)">
            We couldn't analyze your website.
          </Text>
          <Field label="Try to copy and paste all the text from your website in the box below" isRequired>
            <Input
              size="lg"
              autoFocus
              isTextarea
              rows={8}
              placeholder="Paste text"
              name="Website Content"
              onChange={(e) => {
                formikProps.setFieldValue('topic', e.target.value)
                formikProps.setFieldValue('focus', e.target.value)
              }}
              value={formikProps.values.focus}
              errorMessage={errorMessage}
            />
          </Field>
        </div>
      </Form.Fields>
    )
  }

  return (
    <Form.Fields className={Styles.container}>
      <Field label="Add the source content you'd like us to create content around" isRequired>
        <div className={Styles.inputContainer}>
          <Input
            size="lg"
            onKeyDown={(event) => {
              if (event.key === 'Enter') {
                analyzeContent()
              }
            }}
            autoFocus
            placeholder="Enter the URL of your brand’s homepage (“apple.com”)"
            name="Website Link"
            onChange={(e) => formikProps.setFieldValue('content_url', e.target.value)}
            value={contentUrl}
            errorMessage={errorMessage}
            validMessage={contentUrl && contentUrl.length > 0 && isValid ? 'Looks like a valid URL!' : undefined}
          />
        </div>
      </Field>
      <div className={Styles.examplesContainer}>
        <span className={Styles.examplesText}>Good examples to test with:</span>
        <a
          href="https://www.tentree.com/pages/about"
          target="_blank"
          rel="noreferrer"
          onClick={setContentUrl('https://www.tentree.com/pages/about')}
        >
          www.tentree.com/pages/about
        </a>
        <a
          href="https://www.blaze.ai/blog/document-your-journey"
          target="_blank"
          rel="noreferrer"
          onClick={setContentUrl('https://www.blaze.ai/blog/document-your-journey')}
        >
          www.blaze.ai/blog/document-your-journey
        </a>
        <a
          href="https://www.mailchimp.com"
          target="_blank"
          rel="noreferrer"
          onClick={setContentUrl('https://www.mailchimp.com')}
        >
          www.mailchimp.com
        </a>
      </div>
    </Form.Fields>
  )
}
